// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dialog-paper {
    border-radius: 12px !important;
    max-height: 90vh !important;
}

.youtube-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 16px 0 24px !important;
    color: white;
}

.header-content {
    display: flex;
    align-items: center;
}

.header-avatar {
    background-color: rgba(255, 255, 255, 0.2) !important;
    margin-right: 16px !important;
}

.close-button {
    color: white !important;
}

.close-button:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
}

/* Content Styles */
.dialog-content {
    padding: 0 !important;
    background-color: transparent !important;
}


.body-content {
    padding: 24px;
}

/* Video Card Styles */
.video-card {
    margin-bottom: 24px !important;
    border-radius: 8px !important;
    overflow: hidden !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out !important;
}

.video-card:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}

/* Thumbnail Styles */
.thumbnail-container {
    position: relative;
}

.video-thumbnail {
    object-fit: contain !important;
}

.status-chip {
    position: absolute !important;
    top: 16px !important;
    right: 16px !important;
    font-weight: bold !important;
    backdrop-filter: blur(10px) !important;
}

/* Card Content */
.card-content {
    padding: 24px !important;
}


/* Details Grid */
.MuiBox-root.details-grid {
     display:  grid;
        gap: 16px;
}

.MuiBox-root.detail-section {
    padding: 12px 0px 0px 0px;
    elevation: 1;
}


.video-section {
    background-color: #fff8f0 !important;
    border: 1px solid #ffe0b2 !important;
}


.detail-header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.detail-avatar {
    margin-right: 16px !important;
    width: 32px !important;
    height: 32px !important;
}

.channel-avatar {
    background-color: #1976d2 !important;
}

.video-avatar {
    background-color: #ff6b35 !important;
}

.youtube-avatar {
    background-color: #FF0000 !important;
}

.detail-label {
    color: #666 !important;
    font-weight: 600 !important;
}

.MuiTypography-root.detail-value {
    font-family: var(--font-family-primary);
    font-size: 1rem ;
    color: #fff ;
    word-break: break-all ;
}

/* URL Container */
.url-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.MuiTypography-root.url-text {
    color: #1976d2 ;
    cursor: pointer ;
    text-decoration: none ;
    word-break: break-all ;
    flex-grow: 1 ;
}

.MuiTypography-root.url-text:hover {
    text-decoration: underline;
}

.MuiButtonBase-root.launch-button {
    color: #1976d2;
}

.launch-button:hover {
    background-color: #f5f5f5;
}

/* Action Button */
.action-button-container {
    margin-top: 24px !important;
    display: flex !important;
    justify-content: center !important;
}

.youtube-button {
    background: linear-gradient(45deg, #FF0000 30%, #FF4569 90%) !important;
    box-shadow: 0 3px 15px rgba(255, 0, 0, 0.3) !important;
    border-radius: 8px !important;
    padding: 12px 32px !important;
    font-weight: bold !important;
    transition: all 0.3s ease !important;
}

.youtube-button:hover {
    background: linear-gradient(45deg, #E60000 30%, #FF1744 90%) !important;
    box-shadow: 0 5px 20px rgba(255, 0, 0, 0.4) !important;
    transform: translateY(-1px) !important;
}

/* No Videos State */
.no-videos {
    text-align: center;
    padding: 32px 0;
}

/* Responsive Design */
@media (max-width: 768px) {
    .body-content {
        padding: 16px;
    }
    
    .card-content {
        padding: 16px !important;
    }
    
    .video-title {
        font-size: 1.25rem !important;
    }
    
    .MuiBox-root.details-grid {
        gap: 12px;
       display: grid;
        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    }
    
    .MuiBox-root.detail-section {
        padding: 12px 0px;
    }
    
    .youtube-button {
        padding: 10px 24px !important;
        font-size: 0.9rem !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Popup/YouTubePopup/ScheduledPopup.css"],"names":[],"mappings":";AACA;IACI,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qDAAqD;AACzD;;AAEA,mBAAmB;AACnB;IACI,qBAAqB;IACrB,wCAAwC;AAC5C;;;AAGA;IACI,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2BAA2B;IAC3B,qDAAqD;IACrD,8EAA8E;AAClF;;AAEA;IACI,sCAAsC;IACtC,qDAAqD;AACzD;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA,iBAAiB;AACjB;IACI,wBAAwB;AAC5B;;;AAGA,iBAAiB;AACjB;KACK,cAAc;QACX,SAAS;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;;AAGA;IACI,oCAAoC;IACpC,oCAAoC;AACxC;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,kCAAkC;AACtC;;AAEA;IACI,uEAAuE;IACvE,sDAAsD;IACtD,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,uEAAuE;IACvE,sDAAsD;IACtD,sCAAsC;AAC1C;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,SAAS;OACV,aAAa;QACZ,4DAA4D;IAChE;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;AACJ","sourcesContent":["\n.dialog-paper {\n    border-radius: 12px !important;\n    max-height: 90vh !important;\n}\n\n.youtube-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 16px 0 24px !important;\n    color: white;\n}\n\n.header-content {\n    display: flex;\n    align-items: center;\n}\n\n.header-avatar {\n    background-color: rgba(255, 255, 255, 0.2) !important;\n    margin-right: 16px !important;\n}\n\n.close-button {\n    color: white !important;\n}\n\n.close-button:hover {\n    background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n/* Content Styles */\n.dialog-content {\n    padding: 0 !important;\n    background-color: transparent !important;\n}\n\n\n.body-content {\n    padding: 24px;\n}\n\n/* Video Card Styles */\n.video-card {\n    margin-bottom: 24px !important;\n    border-radius: 8px !important;\n    overflow: hidden !important;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;\n    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out !important;\n}\n\n.video-card:hover {\n    transform: translateY(-2px) !important;\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;\n}\n\n/* Thumbnail Styles */\n.thumbnail-container {\n    position: relative;\n}\n\n.video-thumbnail {\n    object-fit: contain !important;\n}\n\n.status-chip {\n    position: absolute !important;\n    top: 16px !important;\n    right: 16px !important;\n    font-weight: bold !important;\n    backdrop-filter: blur(10px) !important;\n}\n\n/* Card Content */\n.card-content {\n    padding: 24px !important;\n}\n\n\n/* Details Grid */\n.MuiBox-root.details-grid {\n     display:  grid;\n        gap: 16px;\n}\n\n.MuiBox-root.detail-section {\n    padding: 12px 0px 0px 0px;\n    elevation: 1;\n}\n\n\n.video-section {\n    background-color: #fff8f0 !important;\n    border: 1px solid #ffe0b2 !important;\n}\n\n\n.detail-header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.detail-avatar {\n    margin-right: 16px !important;\n    width: 32px !important;\n    height: 32px !important;\n}\n\n.channel-avatar {\n    background-color: #1976d2 !important;\n}\n\n.video-avatar {\n    background-color: #ff6b35 !important;\n}\n\n.youtube-avatar {\n    background-color: #FF0000 !important;\n}\n\n.detail-label {\n    color: #666 !important;\n    font-weight: 600 !important;\n}\n\n.MuiTypography-root.detail-value {\n    font-family: var(--font-family-primary);\n    font-size: 1rem ;\n    color: #fff ;\n    word-break: break-all ;\n}\n\n/* URL Container */\n.url-container {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.MuiTypography-root.url-text {\n    color: #1976d2 ;\n    cursor: pointer ;\n    text-decoration: none ;\n    word-break: break-all ;\n    flex-grow: 1 ;\n}\n\n.MuiTypography-root.url-text:hover {\n    text-decoration: underline;\n}\n\n.MuiButtonBase-root.launch-button {\n    color: #1976d2;\n}\n\n.launch-button:hover {\n    background-color: #f5f5f5;\n}\n\n/* Action Button */\n.action-button-container {\n    margin-top: 24px !important;\n    display: flex !important;\n    justify-content: center !important;\n}\n\n.youtube-button {\n    background: linear-gradient(45deg, #FF0000 30%, #FF4569 90%) !important;\n    box-shadow: 0 3px 15px rgba(255, 0, 0, 0.3) !important;\n    border-radius: 8px !important;\n    padding: 12px 32px !important;\n    font-weight: bold !important;\n    transition: all 0.3s ease !important;\n}\n\n.youtube-button:hover {\n    background: linear-gradient(45deg, #E60000 30%, #FF1744 90%) !important;\n    box-shadow: 0 5px 20px rgba(255, 0, 0, 0.4) !important;\n    transform: translateY(-1px) !important;\n}\n\n/* No Videos State */\n.no-videos {\n    text-align: center;\n    padding: 32px 0;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .body-content {\n        padding: 16px;\n    }\n    \n    .card-content {\n        padding: 16px !important;\n    }\n    \n    .video-title {\n        font-size: 1.25rem !important;\n    }\n    \n    .MuiBox-root.details-grid {\n        gap: 12px;\n       display: grid;\n        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n    }\n    \n    .MuiBox-root.detail-section {\n        padding: 12px 0px;\n    }\n    \n    .youtube-button {\n        padding: 10px 24px !important;\n        font-size: 0.9rem !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
